module.exports = __webpack_public_path__ + "static/media/integrations-module-group2.634fde60.svg";